<script setup lang="ts">
interface UnCheckedCircle {
	size?: string;
	class?: string;
	outerFill?: string; // NEW: outer circle fill
	outerStroke?: string; // NEW: outer circle stroke
	innerFill?: string; // NEW: inner circle fill
}

const props = defineProps<UnCheckedCircle>();
</script>

<template>
	<svg
		:width="props.size || '20'"
		:height="props.size || '20'"
		:class="props.class"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<!-- Outer circle -->
		<path
			d="M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10Z"
			:fill="props.outerFill || '#424242'"
		/>
		<path
			d="M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10Z"
			:stroke="props.outerStroke || '#424242'"
		/>
		<!-- Inner circle -->
		<rect
			x="6"
			y="6"
			width="8"
			height="8"
			rx="4"
			:fill="props.innerFill || 'white'"
		/>
	</svg>
</template>
